import { useEffect } from 'react';
import { useAnalytics } from './useAnalytics';

interface Props {
  trackEvent: string;
  componentRef: any;
  allProps?: any;
  eventParams?: any;
}

const useTrackComponentInteraction = ({
  trackEvent = '',
  componentRef,
  allProps = {},
  eventParams = {},
}: Props) => {
  const { track, groupIdentify } = useAnalytics();

  useEffect(() => {
    if (['component_interaction', 'restaurant_impression'].includes(trackEvent)) {
      const currentComponentRef = componentRef.current;
      let componentIsVisible = false;
      let timer: any;
      const handleTrack = () => {
        track(trackEvent, {
          ...allProps,
          ...eventParams,
          // duration,
        });
        if (trackEvent === 'restaurant_impression') {
          groupIdentify('restaurant', allProps.component_id, {
            ...(allProps.component_detail && { restaurant_name: allProps.component_detail }),
          });
        }
      };

      const startTimer = () => {
        timer = setTimeout(() => {
          handleTrack();
        }, 1000);
      };

      const clearTimer = () => {
        clearTimeout(timer);
      };

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && trackEvent) {
              if (!componentIsVisible) {
                componentIsVisible = true;
                startTimer();
              }
            } else {
              clearTimer();
              componentIsVisible = false;
            }
          });
        },
        { threshold: 0.5 }
      );

      if (currentComponentRef) {
        observer.observe(currentComponentRef);
      }

      return () => {
        if (currentComponentRef) {
          observer.unobserve(currentComponentRef);
          clearTimer();
        }
      };
    }
  }, [allProps, componentRef, eventParams, groupIdentify, track, trackEvent]);
};

export default useTrackComponentInteraction;
